const axios = require("axios")
const master = axios.create()

let abortController = {}

master.interceptors.request.use(
    async config => {
        let abortActive = _.get(config, 'abort', true)
        const token = _.get(window, "MasterGlobals.adminApiToken", _.get(window, "TenantGlobals.adminToken"))
        config.baseURL = process.env.MIX_APP_URL
        config.headers.Authorization = `Bearer ${token}`
        if (abortActive) {
            if (_.get(abortController, config.url, false)) {
                abortController[config.url].abort()
            }
            Vue.set(abortController, config.url, new AbortController())
            config.signal = abortController[config.url].signal
        }
        return config
    },
    error => {
        error.output = function() {
            if (error.message !== 'canceled') {
                return console.error(error)
            }
            return true
        }
        Promise.reject(error)
    }
)

// Response interceptor for API calls
master.interceptors.response.use(
    response => {
        Vue.delete(abortController, response.config.url)
        return response
    },
    async function (error) {
        const originalRequest = error.config

        if (_.get(error, 'response', false)) {

            window.onbeforeunload = null

            if (error.response.status == 401) {
                window.location = window.location.href;
            }

            if (error.response.status === 403 && !originalRequest._retry) {
                originalRequest._retry = true
            }
        }

        error.output = function() {
            if (error.message !== 'canceled') {
                return console.error(error)
            }
            return true
        }

        return Promise.reject(error)
    }
)


// create refreshAccessToken() function for popup to allow failed api call and refresh relevant global token

export default master
